;(function() {
  'use strict'

  angular.module('app.core').component('tileMenu', {
    controller: Controller,
    templateUrl: 'tile-menu.html',
    bindings: {
      created: '<',
      updated: '<',
      items: '&?',
    },
  })

  /* @ngInject */
  function Controller() {
    var ctrl = this

    ctrl.refresh = refresh

    function refresh() {
      ctrl.createdAt = ctrl.created && moment(ctrl.created)
      ctrl.updatedAt = ctrl.updated && moment(ctrl.updated)

      var items = _.compact(ctrl.items ? ctrl.items() : [])
      ctrl.actions = _.reject(items, 'last')
      ctrl.lastActions = _.filter(items, 'last')
    }
  }
})()
